export default "/images/2c65089838cf7046cfc840b184116169.avif";